import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AvailableProductItem from "./AvailableProductItem";
import { useAvailableProductCartUseMemo } from "../../../hooks/use-memo/useAvailableProductCartUseMemo";
import { ErrorProductCart, LoadingProductCart, NoAvailableProductCart } from "./ApiReturnProductCart";
import useGuestAction from "../../../hooks/actions/useGuestAction";
import { selectCategories, selectSize, setAvailableCategories, setAvailableSize } from "../../../features/guest/guestSlice";

export default function ProductCard() {

    const dispatch = useDispatch()
    const selectedCategories = useSelector(selectCategories)
    const selectedSize = useSelector(selectSize)
    const { availableProductOfClient, isLoadingAvailableProductOfClient, isErrorAvailableProductOfClient, errorMessage, filteredProducts, sortedCategories } = useAvailableProductCartUseMemo({selectedCategories, selectedSize})
    const { handleAddCart } = useGuestAction()

    useEffect(() => {
        if (!availableProductOfClient?.data) return;

        // const uniqueCategories = Array.from(
        //     new Set(availableProductOfClient.data.map(item => item.categoryName))
        // );
        const uniqueCategories = [
            "All",
            ...Array.from(
                new Set(availableProductOfClient.data.map(item => item.categoryName))
            ),
        ];

        // const uniqueSizes = Array.from(
        //     new Set(availableProductOfClient.data.map(item => item.size))
        // );

        let products = availableProductOfClient.data;

        // Filter products by selected category
        if (
            selectedCategories.length > 0 &&
            !selectedCategories.includes("All")
        ) {
            products = products.filter(product =>
                selectedCategories.includes(product.categoryName)
            );
        }

        const uniqueSizes = [
            "All",
            ...Array.from(
                new Set(products.map(item => item.size))
            ),
        ];

        dispatch(setAvailableCategories(uniqueCategories))
        dispatch(setAvailableSize(uniqueSizes))
    }, [availableProductOfClient?.data, dispatch, selectedCategories, selectedSize]);
    
    const noProductAvailable = !availableProductOfClient?.data?.length || filteredProducts.length === 0 

    if (isLoadingAvailableProductOfClient) return <LoadingProductCart/>

    if (isErrorAvailableProductOfClient) return <ErrorProductCart errorMessage={errorMessage}/>

    if (noProductAvailable) return <NoAvailableProductCart/>

    return (
        <div className="overflow-hidden rounded">
            <div className="py-2 pr-1 h-full overflow-y-auto">
                <div className="grid gap-3">
                    {sortedCategories.map(([category, products]) => (
                        <div key={category} className="space-y-2">
                            <p className="text-xs md:text-sm font-medium text-gray-700">
                                {category}
                            </p>
                            <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2">
                                {products.map((product, index) => (
                                    <AvailableProductItem
                                        key={index}
                                        product={product}
                                        category={category}
                                        onClick={handleAddCart}
                                    />
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}